module["exports"] = [
  "#{street_name}#{building_number}",
  "#{street_name}#{building_number} #{secondary_address}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es_MX/address/street_address.js
// module id = 1078
// module chunks = 1